import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  missingChartMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: `1px solid ${colors.borderGray}`,
    padding: ' 0 32px',
    fontSize: 18,
    textAlign: 'center',
    height: 250,
    '& p': {
      margin: 0
    },
    '& p + p': {
      marginTop: 16
    }
  }
}

export const useStyles = createUseStyles(style)
